import { FormlyModule } from '@ngx-formly/core';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { DragSlideToggleComponent } from './components';
import { SnDragSlideToggleFormField } from './components/field-type/drag-slide-toggle.field-type';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    ReactiveFormsModule,
    // Material
    MatSlideToggleModule,
    DragDropModule,
    // Formly
    FormlyModule.forChild({
      types: [
        {
          name: 'drag-slide-toggle',
          component: SnDragSlideToggleFormField,
          wrappers: ['form-field'],
        },
      ],
    }),
  ],
  declarations: [DragSlideToggleComponent, SnDragSlideToggleFormField],
  exports: [DragSlideToggleComponent],
})
export class SnDragSlideToggleModule {}
